import http from "@utils/request";

// let protocol=window.location.protocol;

// 获取管径分析报告
export const getPipeHeatAnalysis=(sectionId,page=1,size=10)=>http({
  url: "/analysis/getPipeHeatAnalysis"
  ,data:{
    sectionId,page,size
  }
});
// 获取保温分析报告
export const getPipeInsulaAnalysis=(sectionId,page=1,size=10)=>http({
  url: "/analysis/getPipeInsulaAnalysis"
  ,data:{
    sectionId,page,size
  }
});

// 生成分析报告
export const createReport=(sectionId,start_time,end_time,energy_type)=>http({
  url: "/analysis/getPipeAnalysisByPramas"
  ,data:{
    sectionId,start_time,end_time,energy_type
  }
});

// 分页获取管段历史数据
export const getPipelineAnalysis=(sectionId,starttime,endtime,page=1,size=10)=>http({
  url: "/analysis/pipeline_analysis"
  ,data:{
    sectionId,starttime,endtime,page,size
  }
  // 配置何时不添加loading动画
  ,unloading:[
    "/list/ppcurve"
  ]
});

// 获取管段报警数据
export const findAlarmInterval=(sectionId,starttime,endtime,velocity_min,overHeat_min,hLoss_min)=>http({
  url: "/analysis/findAlarmInterval"
  ,data:{
    sectionId,starttime,endtime,velocity_min,overHeat_min,hLoss_min
  }
});
